import { render, staticRenderFns } from "./ScreenBlocker.vue?vue&type=template&id=cafd947c&scoped=true&lang=html&"
import script from "./ScreenBlocker.vue?vue&type=script&lang=js&"
export * from "./ScreenBlocker.vue?vue&type=script&lang=js&"
import style0 from "./ScreenBlocker.vue?vue&type=style&index=0&id=cafd947c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafd947c",
  null
  
)

export default component.exports